export const ReadOnlyNote = ({
  text = "Updated daily by TINA",
}: {
  /** The default is the league/team/match source fields; the child documents use AfterMatchNote. */
  text?: string;
}) => <p className="text-xs text-muted-foreground">{text}</p>;

/** The standings, match details and season stats sections: TINA rewrites them after each match. */
export const AfterMatchNote = () => (
  <ReadOnlyNote text="Updated by TINA after each match" />
);
